export function handleMoveFreeTextSearchElement()
{
	if (window.location.href.indexOf(siteSearchPage) === -1 || window.location.href.indexOf('?result') === -1) {
        var width = $(window).outerWidth();
        if (width > 767) {
            moveFreeTextSearchElement(false);
        }
        else {
            moveFreeTextSearchElement(true);
        }
    }
}

function moveFreeTextSearchElement( alt )
{
	if( (alt && $('.mobileNavBtnEsmark #search-kat-number').length > 0) || ( !alt && $('#header .heading-top #search-kat-number').length > 0 ) )
	{
		return false;
	}

	if( alt === true )
	{
		if(typeof isLodgingPage === 'undefined' || isLodgingPage === false)
		{
			$('#search-kat-number').appendTo($('#navigation .freeTextSearchReceiver'));
			setFilterBtnTextDisplay(false)
		}
	}
	else
	{
		$('#search-kat-number').insertBefore($('#header .heading-top .top-ul-wrap'));
	}
}

function setFilterBtnTextDisplay( show )
{
	if(show === true)
	{
		$('.mobileSearchBtnEsmark .searchBtnText').removeClass('hidden');
	}
	else
	{
		$('.mobileSearchBtnEsmark .searchBtnText').addClass('hidden');
	}
}
